"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconAgent = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M59 40.79L56.3 22.5a9 9 0 0 0-12.5-6.89l-6.48 2.88a5.75 5.75 0 0 1-4.66 0l-6.48-2.88A9 9 0 0 0 13.7 22.5L11 40.79C5.06 42.06.7 44 .7 46.94c0 6.5 21.56 8.23 34.3 8.23s34.3-1.73 34.3-8.23c0-2.94-4.36-4.88-10.3-6.15zm-39.2-22a5.71 5.71 0 0 1 5.11-.22l6.48 2.88a9 9 0 0 0 7.26 0l6.47-2.88a5.76 5.76 0 0 1 8 4.43l2 13.48c-1.73.9-8.5 2.26-20.11 2.26s-18.38-1.37-20.11-2.26l2-13.48a5.72 5.72 0 0 1 2.88-4.24zM35 41.91c2.83 0 15-.13 20.58-2.24l.67 4.55c-1.65.92-8.8 2.37-21.25 2.37s-19.6-1.45-21.25-2.37l.67-4.55C20 41.78 32.17 41.91 35 41.91zM35 52c-19.34 0-30.25-3.19-31.08-5 .35-.77 2.62-1.8 6.61-2.73a2.12 2.12 0 0 0-.05.4c0 2 2.34 3.22 8.07 4.12a112.11 112.11 0 0 0 16.45 1 112.13 112.13 0 0 0 16.46-1.07c5.73-.9 8.07-2.09 8.07-4.12a2.11 2.11 0 0 0 0-.4c4 .93 6.25 2 6.6 2.73C65.25 48.77 54.34 52 35 52z"
  })),
  height: undefined,
  width: undefined
});
IconAgent.displayName = 'IconAgent';
var _default = IconAgent;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/agent.js
// module id = 554
// module chunks = 0